<template>
  <div
    id="outer"
    class="h-100 flex flex-col flex-grow"
  >
    <AppHeader class="flex" />
    <main class="flex flex-1">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './Header'
import AppFooter from './Footer'

export default {
  components: { AppHeader, AppFooter }
}
</script>
